/*
 * @Author: wangkg wangkegui@longfor.com
 * @Date: 2022-12-08 14:57:26
 * @LastEditors: wangkg wangkegui@longfor.com
 * @LastEditTime: 2022-12-20 11:28:12
 * @FilePath: /low-code/src/utils/common.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 下载方法
 * @param {*} data 
 * @param {*} fileName 
 */
// export const downloadFile = (data, fileName) => {
//   // 将二进制文件转换为可访问的url
//   const url = window.URL.createObjectURL(data)
//   const a = document.createElement('a')
//   document.body.appendChild(a)
//   a.href = url
//   fileName && (a.download = fileName)
//   a.click()
//   window.URL.revokeObjectURL(url)
// }

export const downloadFile = (data, fileName = '模版.xlsx') => {
  // 将二进制文件转换为可访问的url
  // let blob = new Blob([data], { type: 'application/vnd.ms-excel' });
  let blob = new Blob([data]);
  let downloadElement = document.createElement('a');
  let href = window.URL.createObjectURL(blob);
  downloadElement.href = href;
  downloadElement.download = fileName;
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement);
  window.URL.revokeObjectURL(href);
}
